"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class GetProviderUsersError extends client_library_1.ExtendableError {
    constructor(reason) {
        super(reason);
    }
}
exports.default = GetProviderUsersError;
